// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "./controllers";

ActiveStorage.start();

// When a turbo-frame request comes back without the expected frame — e.g. the
// server redirected to the login or root page because the session expired or
// authorisation failed — Turbo otherwise replaces the frame with a bare
// "Content missing" message. Fall back to a full page visit so the user lands
// on the real page (login, root, …) instead.
document.addEventListener("turbo:frame-missing", (event) => {
  const { detail: { response, visit } } = event;
  event.preventDefault();
  visit(response.url);
});

import "trix"
import "@rails/actiontext"
